export { default } from './getDisplayName';
export * from './getDisplayName';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getDisplayName/index.js
// module id = 304
// module chunks = 25